import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';

import MfpartySelection from 'core/components/party-mgmt/action/SelectParty/MfpartySelection';
export default function SelectPartyActionImpl(){

    return (
        <MfpartySelection/>
    )
}